import { Collapse, Select } from "antd";
import React, { useEffect, useState } from "react";
import "./style.scss";
import { FormattedMessage, useIntl } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import { getActivities } from "../../../store/actions/precog";
import VatEntriesFilters from "./filters";
import VatEntriesTable from "./table";
import { getVatSettlemenDetails } from "../../../store/actions/reports/vatSettlement";

const Panel = Collapse.Panel;
const Option = Select.Option;

const VatEntriesPage = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const entriesData = useSelector(state => state.reports.vat?.aliquoteDetail);
  const businesses = useSelector(state => state.precog.activities?.data);
  const currentYear = new Date().getFullYear();

  const [selectedBusiness, setSelectedBusiness] = useState(undefined); 
  const [selectedSectional, setSelectedSectional] = useState(undefined); 
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(undefined);  
  const [selectedType, setSelectedType] = useState(undefined);  

  useEffect(() => {
    dispatch(getActivities());
  }, []);

  const renderSectionals = () => {
    const businessesArray = [];
    if (businesses?.length > 1) {
      businessesArray.push(<Option
        key={"sectionals_select_all"}
        value={"all"}
      >
        Tutti
      </Option>);
    } 
    businesses?.forEach((el, index) => {
      businessesArray.push(<Option
        key={"sectionals_select_" + el.sectionalId}
        value={el.sectionalId}
      >
        {el.sectionalDescription}
      </Option>);
    });
    return businessesArray;
  };

  return (
    <div className="entries-page">     
      <Collapse
        bordered={false}
        defaultActiveKey={["1"]}
        expandIcon={({ isActive }) => <div className="title"><FontAwesomeIcon icon={["far", isActive? "chevron-up": "chevron-down"]}/></div>} 
        className="site-collapse-custom-collapse"
      >
        <Panel header={<div className="title">
          <FormattedMessage id="reports.vatEntries.title"/>
        </div>} 
        key="1" className="site-collapse-custom-panel">
          <VatEntriesFilters
            selectedBusiness={selectedBusiness}
            setSelectedBusiness={setSelectedBusiness}
            selectedYear={selectedYear}
            setSelectedYear={setSelectedYear}
            selectedMonth={selectedMonth}
            setSelectedMonth={setSelectedMonth}
            selectedType={selectedType}
            setSelectedType={setSelectedType}
          />
        </Panel>
      </Collapse>
      {entriesData?.length > 0 ?
        <div style={{padding: "16px"}}>
          <div style={{paddingBottom: "16px", borderBottom: "1px solid #c9d9e8"}}>
            <div className="business-summary-title">
              <FormattedMessage id="reports.vatEntries.businessSummary"/>
            </div>
            <div>
              {businesses?.length === 1 ?
                <>
                  <div className="business-summary-list">{businesses[0].businessDescription}</div>
                  <div>
                    <div><FormattedMessage id="reports.vatEntries.sectionalRef" /></div>
                    <Select
                      style={{ width: 239, paddingTop: 4 }}
                      showSearch
                      placeholder={intl.formatMessage({ id: "reports.vatEntries.sectionalRefPlaceholder" })}
                      optionFilterProp="children"
                      getPopupContainer={trigger => trigger.parentNode}
                      value={selectedSectional}
                      filterOption={(input, option) => {
                        return option.children.toString().indexOf(input) >= 0;
                      }}
                      onSelect={value => {
                        setSelectedSectional(value);
                        dispatch(getVatSettlemenDetails(
                          selectedBusiness === "all" ? "" : selectedBusiness, selectedYear, selectedMonth, "", selectedType === "all" ? "" : selectedType, value
                        ));
                      }}
                    >
                      {renderSectionals()}
                    </Select>
                  </div>
                </> : 
                selectedBusiness === "all" ? businesses?.map(el => <div className="business-summary-list" key={el.businessId}>{el.businessDescription}</div>) : 
                  <div className="business-summary-list">
                    {businesses?.find(el => el.businessId === selectedBusiness)?.businessDescription ?? ""}
                  </div>
              }
            </div>
          </div>
          <div style={{ paddingTop: "12px" }}>
            {/*
            https://teamsystem.atlassian.net/browse/DOP-1597
            Hidden until new order
            <div style={{paddingBottom: "12px", display: "flex", justifyContent: "end", gap: "32px"}}>
              <FontAwesomeIcon className="icon" icon={["far", "download"]} />
              <FontAwesomeIcon className="icon" icon={["far", "print"]} />
            </div>
            */}
            <VatEntriesTable />
          </div>
        </div>
        : null}
    </div>
  );
};
export default VatEntriesPage;
